import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MDTagComponent } from '@melodic-ui/components';
import { ILessonListItem } from '../../../api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';
import { AccountStateService } from '@lb/state/account-state.service';
import { TzDatePipe, TzTimePipe } from '@lb/pipes/timezone-aware-date.pipe';

@Component({
	standalone: true,
	imports: [CommonModule, RouterModule, NotificationBaseComponent, MDTagComponent, TzDatePipe, TzTimePipe],
	selector: 'lb-notification-rescheduled',
	template: `@if (lesson()) {
		<lb-notification-base [notification]="notification()">
			<div activity-message>
				Rescheduled {{ lesson().originalLessonDate | tzDate: 'MMM d' }} lesson for <b>{{ lesson().languageName }} {{ lesson().languageLevelName }}</b> to
				<b>
					{{ lesson().lessonDate | tzDate: 'MMM d' }}, {{ lesson().lessonDate | tzTime: 'shortTime' }} - {{ lesson().lessonEndDate | tzTime: 'shortTime' }}.
				</b>
			</div>
			<div activity-action class="flex-actions">
				@if (lesson().makeUp) {
					<md-tag>Makeup Lesson</md-tag>
				}
				<button md-button (click)="dismissNotifications()">Dismiss</button>
			</div>
		</lb-notification-base>
	}`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationRescheduledComponent extends NotificationBaseComponent {
	private readonly accountStateService = inject(AccountStateService);

	isInstructor = computed(() => this.accountStateService.isInstructor());
	// Hydrated by Notification.Api from Lesson.Api (LessonListItem shape).
	lesson = computed(() => this.notification().data as ILessonListItem);

	// Only show name if the current user is instructor
	name = computed(() => {
		if (this.isInstructor()) {
			return this.lesson().learnerFullName;
		}
		return null;
	});
}
